export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/call_of_duty.34fdddc.svg";